module.exports = __webpack_public_path__ + "img/info-24px.ea6f6a2b.svg";